import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeSv from '@angular/common/locales/sv';
import { LOCALE_ID, NgModule } from '@angular/core';
import { APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MenuItemDisplayValueComponent } from './core/components/menu-item-display-value/menu-item-display-value.component';
import { MenuItemComponent } from './core/components/menu-item/menu-item.component';
import { NotFoundComponent } from './core/components/not-found/not-found.component';
import { ToolbarComponent } from './core/components/toolbar/toolbar.component';
import { AuthInterceptor } from './core/http-interceptors/auth-interceptor';
import { DashboardModule } from './features/dashboard/dashboard.module';
import { GrocyModule } from './features/grocy/grocy.module';
import { TimeModule } from './features/time/time.module';
import { MaterialModule } from './material.module';
import { SharedModule } from './shared/shared.module';

registerLocaleData(localeSv, 'sv-SE');

@NgModule({
  declarations: [AppComponent, MenuItemComponent, MenuItemDisplayValueComponent, NotFoundComponent, ToolbarComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    DashboardModule,
    GrocyModule,
    MaterialModule,
    SharedModule,
    TimeModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'sv-SE' },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: true,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
})
export class AppModule {}
